import { User, Role } from './user';
import { AuthData, AuthError, RegistrationData } from './auth';
import { EmailVerificationData } from './emailVerification';

export * from './user';
export * from './auth';
export * from './emailVerification';

export interface StoreState {
  /** Authenticaton/authorization data for the currently logged in user */
  authData: AuthData;

  /** Any error that occurred during the authentication process */
  authError: AuthError;

  /** Registration/signup data for the current user */
  registrationData: RegistrationData;

  /** Email verification data for the current user */
  emailVerificationData: EmailVerificationData;

  /** Whether the application has been initialized yet */
  initialized: boolean;

  /** A list of users of the app, indexed by ID */
  users: { [index: string]: User };

  /** Roles available to be assigned to users added by the administrator */
  roles: Role[];

  /** Any error that occurs while updating user data */
  userError: string;

  branding: BrandingData;

  /** Flag to check if translations are available and trigger re-render if necessary */
  languageReady: boolean;
}

export interface BrandingData {
  logoFile: string;
  primaryColor: string;
  secondaryColor: string;
  actionColor: string;
  headline: string;
  subtext: string;
  /** URL of federated login provider, if one exists */
  externalLoginUrl?: string;
}

export enum InitializationState {
  loading = 'loading',
  authorized = 'authorized',
  unauthorized = 'unauthorized'
}



// WEBPACK FOOTER //
// ./src/types/index.ts